import * as React from 'react';
import { useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Message } from 'semantic-grab-ui/src';
import { isEmpty } from 'lodash';
import { setBannerCookie, getBannerCookie } from 'utils/user-utils';
import './BannerMessage.scss';

type BannerMessageProps = {
  bannerMessage: string;
};

export const BannerMessage: React.FunctionComponent<BannerMessageProps> = ({
  bannerMessage = '',
}) => {
  const [viewed, setViewed] = useState(false);
  const existingCookie = getBannerCookie();
  const hideBanner =
    isEmpty(bannerMessage) ||
    existingCookie === bannerMessage ||
    viewed === true;
  const [bannerHeader, bannerText] = bannerMessage.split('|');
  const dismissFn = () => {
    setBannerCookie(bannerMessage);
    setViewed(true);
  };
  return (
    <Message
      info
      hidden={hideBanner}
      onDismiss={dismissFn}
      className="banner-message"
    >
      <Message.Header>{bannerHeader}</Message.Header>
      <Message.Content><div dangerouslySetInnerHTML={{ __html: bannerText}} /></Message.Content>
    </Message>
  );
};

const mapStateToProps = ({
  app: {
    config: { bannerMessage },
  },
}) => ({
  bannerMessage,
});

export default compose(connect(mapStateToProps), withRouter)(BannerMessage);
